import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import ContentBackgroundImage from './src/components/ContentBackgroundImage';
import ProductHeader from './src/components/ProductHeader';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'productHeader',
        component: ProductHeader,
      },
      {
        key: 'contentBackgroundImage',
        component: ContentBackgroundImage,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
